(function (window, document) {
  'use strict';

  var CLICK_ID_PARAMS = {
    gclid: true,
    fbclid: true,
    msclkid: true,
    ttclid: true
  };

  function isProductBenefitsPage() {
    return Boolean(document.getElementById('protoarc-benefits-module'));
  }

  function getTrackingParams() {
    var current = new URL(window.location.href);
    var tracking = [];

    current.searchParams.forEach(function (value, key) {
      var normalizedKey = key.toLowerCase();

      if (normalizedKey.indexOf('utm_') === 0 || CLICK_ID_PARAMS[normalizedKey]) {
        tracking.push([key, value]);
      }
    });

    return tracking;
  }

  function decorateLink(link, trackingParams) {
    var rawHref = link.getAttribute('href');

    if (!rawHref || rawHref.charAt(0) === '#' || link.hasAttribute('download')) return;

    var url;

    try {
      url = new URL(rawHref, window.location.href);
    } catch (error) {
      return;
    }

    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return;

    trackingParams.forEach(function (entry) {
      url.searchParams.set(entry[0], entry[1]);
    });

    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function init() {
    if (!isProductBenefitsPage()) return;

    var trackingParams = getTrackingParams();

    if (!trackingParams.length) return;

    document.querySelectorAll('a[href]').forEach(function (link) {
      decorateLink(link, trackingParams);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var link = target && typeof target.closest === 'function'
        ? target.closest('a[href]')
        : null;

      if (link) decorateLink(link, trackingParams);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window, document);
